// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { type Selector } from '../../../types/selectors';
import { type ClientUpdaterState } from '../reducers/clientUpdater';

export const selectClientUpdaterState: Selector<ClientUpdaterState> = createSelector(
  (state: StateType) => state,
  (state) => state.clientUpdater,
);

export const selectIsClientUpdateDeprecated: Selector<boolean> = createSelector(
  selectClientUpdaterState,
  (clientUpdaterState) => clientUpdaterState.isClientDeprecated,
);

export const selectIsClientUpdateMandatory: Selector<boolean> = createSelector(
  selectClientUpdaterState,
  (clientUpdaterState) => clientUpdaterState.isClientUpdateMandatory,
);

export const selectClientUpdaterHasDismissTheWarnAtLeastOnce: Selector<boolean> = createSelector(
  selectClientUpdaterState,
  (clientUpdaterState) => clientUpdaterState.hasDismissTheWarnAtLeastOnce,
);
